import "./../../../../pages/audit complet/simulation/simulation.css";
import "./DeclarationPER.css";
import "../../AuditComplet/ContexteFiscal/ContexteFiscal.css";
import { useState, useContext, useEffect } from "react";
import { FaPrint, FaSave, FaUndo, FaFileAlt, FaCalculator, FaSync, FaArrowLeft, FaQuestionCircle } from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import { applyFormat } from "components/ui/ui-helpers";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";
import { SyntheseDeclarationPER } from "components/app/Api/Rapport/ApiRapport";
import _ from "lodash";
import { GetCalculDeclaPER } from "components/app/Api/ApiSimulateur";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import { useStudyManagementHandlers } from "pages/studyManagementHandler";
import { CustomTooltip } from "components/ui/controls/custom-tooltip/custom-tooltip";
import { createStyledButton } from "components/ui/controls/button/button-styles";

const DeclarationPER = (props) => {
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalSave, setModalSave] = useState(false);
  const { handleSave, handleGoToAudits } = useStudyManagementHandlers(props);
  const initialValues = {
    DeclaPERRemunerationImposable: 0,
    DeclaPERRegimeFiscal: "tns",
    DeclaPERAbondementPERCO: 0,
    DeclaPERRetraiteMadelin: 0,
    DeclaPERPrevoyanceMadelin: 0,
    DeclaPERRetraite83: 0,
    DeclaPERRetraite163: 0,
  };
  const [values, setValues] = useState(initialValues);
  const [resultat, setResultat] = useState({
    MontantAssietteDisponible: 0,
    MontantAssietteDisponibleT1: 0,
    MontantAssietteDisponibleT2: 0,
    MontantDisponibleT1: 0,
    MontantDisponibleT2: 0,
    MontantADeclarer: 0,
  });

  useEffect(() => {
    let NewValues = _.cloneDeep(values);
    NewValues.DeclaPERRemunerationImposable = context.state.DeclaPERRemunerationImposable;
    NewValues.DeclaPERRegimeFiscal = context.state.DeclaPERRegimeFiscal;
    NewValues.DeclaPERAbondementPERCO = context.state.DeclaPERAbondementPERCO;
    NewValues.DeclaPERRetraiteMadelin = context.state.DeclaPERRetraiteMadelin;
    NewValues.DeclaPERPrevoyanceMadelin = context.state.DeclaPERPrevoyanceMadelin;
    NewValues.DeclaPERRetraite83 = context.state.DeclaPERRetraite83;
    NewValues.DeclaPERRetraite163 = context.state.DeclaPERRetraite163;
    setValues(NewValues);
  }, []);

  const dt = new Date();
  const yearM1 = dt.getFullYear() - 1;
  const year = dt.getFullYear();
  const handleCalcul = (Property, value) => {
    context.handleValueChange(Property, value);
    let NewValues = _.cloneDeep(values);
    NewValues[Property] = value;
    setValues(NewValues);
    GetCalculDeclaPER(NewValues, "CalculDeclaPER").then((res) => {
      if (typeof res === "object") {
        setResultat(res);
        context.handleValueChange("DeclaPERResultat", res);
      }
    });
  };
  return (
    <>
      <Column fill>
        
        <Row style={{ alignItems: "stretch" }} className="declaration-per-layout">
          <Column fill style={{ minWidth: "640px", maxWidth: "820px", display: "flex", flexDirection: "column" }} className="declaration-per-left-column">
            <CardBox className="blockRoundedForce" bpad style={{ flex: 1, padding: "25px" }}>
              <div className="revenuspro-container" style={{ paddingLeft: "0px" }}>
                {/* Titre au-dessus du tableau */}
                <div className="dossier-header" style={{ marginBottom: "15px" }}>
                  <div className="dossier-header-icon">
                    <FaFileAlt />
                  </div>
                  <h1 className="dossier-header-title">Aide à la déclaration PER</h1>
                </div>

                {/* Header des colonnes */}
                <div className="header-card">
                  <div className="category-column" style={{ textAlign: "left", flex: 2 }}>
                    Paramètres
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    Valeurs
                  </div>
                </div>

                {/* Conteneur des cartes de contenu */}
                <div className="card-list-container">
                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">💰</div>
                      Rémunération imposable {yearM1}
                    </div>
                    <div className="value-column">
                      <TextField
                        value={values.DeclaPERRemunerationImposable}
                        onChange={(e) => {
                          handleCalcul("DeclaPERRemunerationImposable", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">👔</div>
                      Régime fiscal
                    </div>
                    <div className="value-column">
                      <DropDown
                        value={values.DeclaPERRegimeFiscal}
                        onChange={(e) => {
                          handleCalcul("DeclaPERRegimeFiscal", e.target.value);
                        }}
                        options={[
                          { value: "tns", label: "Revenus des gérants (art 62 du CGI)" },
                          { value: "bic", label: "BIC/BNC" },
                          { value: "salaire", label: "Traitement et salaires" },
                        ]}
                        style={{
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">🤝</div>
                      Abondement PERCO net de PS {yearM1}
                       <CustomTooltip
                            tooltipStyle={{ minWidth: "300px", textAlign: "justify", padding: "14px" }}
                            type="info"
                            content={
                              <>
                                ✨ Le logiciel prévoit la possibilité de racheter des trimestres au titre : <br />
                                <br />- Des années incomplètes. <br />
                                <br />- Des années d’études supérieures (attention, le logiciel ne prévoit pas la réduction tarifaire en cas de rachat d’années d’études intervenant dans les
                                10 ans suivants les études). Nous vous rappelons que la demande de rachat s’effectue auprès du premier régime auquel l’assuré a été affilié après ses études.
                                <br />
                                <br />
                                Le rachat en option 1 influe sur le taux de pension et permet donc de réduire ou d’annuler la décote. Le rachat en option 2 influe sur le taux et la durée
                                d'assurance retenue pour le calcul de la retraite du régime unifié.
                              </>
                            }
                          >
                            <Button
                              icon
                              {...createStyledButton("card-action", "cardEdit", {
                                backgroundColor: "#dbeafe",
                                padding: "6px",
                                minWidth: "28px",
                                width: "40px",
                                height: "24px",
                              })}
                            >
                              <FaQuestionCircle className="icon-14px" style={{ color: "#3b82f6" }} />
                            </Button>
                          </CustomTooltip>
                    </div>
                    <div className="value-column">
                      <TextField
                        value={values.DeclaPERAbondementPERCO}
                        onChange={(e) => {
                          handleCalcul("DeclaPERAbondementPERCO", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                                             
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">🏦</div>
                      Cotisations retraite Madelin {yearM1}
                    </div>
                    <div className="value-column">
                      <TextField
                        value={values.DeclaPERRetraiteMadelin}
                        onChange={(e) => {
                          handleCalcul("DeclaPERRetraiteMadelin", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">🛡️</div>
                      Cotisations prévoyance et santé Madelin {yearM1}
                    </div>
                    <div className="value-column">
                      <TextField
                        value={values.DeclaPERPrevoyanceMadelin}
                        onChange={(e) => {
                          handleCalcul("DeclaPERPrevoyanceMadelin", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">🧮</div>
                      Cotisations retraite 83 {yearM1}
                    </div>
                    <div className="value-column">
                      <TextField
                        value={values.DeclaPERRetraite83}
                        onChange={(e) => {
                          handleCalcul("DeclaPERRetraite83", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">🏛️</div>
                      Cotisations PER 163 quatervicies {yearM1}
                    </div>
                    <div className="value-column">
                      <TextField
                        value={values.DeclaPERRetraite163}
                        onChange={(e) => {
                          handleCalcul("DeclaPERRetraite163", e.target.value);
                        }}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </CardBox>
          </Column>

          <Column fill style={{ maxWidth: "870px", display: "flex", flexDirection: "column" }} className="declaration-per-right-column">
            <CardBox bpad className=" blockRoundedForce" style={{ padding: "20px", display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
              <Column fill style={{ padding: "10px 5px" }}>
                <div className="action-button-container">
                  <ActionButton
                    onClick={() => {
                      context.handleRemiseDonneeDeclarationPER();
                      setValues(initialValues);
                    }}
                    icon={FaUndo}
                    title="Réinitialiser"
                    subtitle="Remettre à zéro"
                    colors={{
                      primary: "#3b82f6",
                      secondary: "#1d4ed8",
                      shadow: "rgba(59, 130, 246, 0.4)",
                      shadowHover: "rgba(59, 130, 246, 0.6)",
                    }}
                    decorativeIcon={{ type: "undo" }}
                  />
                  <ActionButton
                    onClick={() => {
                      SyntheseDeclarationPER(context.state, resultat);
                    }}
                    icon={FaPrint}
                    title="Impression"
                    subtitle="Editer un Word"
                    colors={{
                      primary: "#11998e",
                      secondary: "#0d7377",
                      shadow: "rgba(17, 153, 142, 0.4)",
                      shadowHover: "rgba(17, 153, 142, 0.6)",
                    }}
                    decorativeIcon={{ type: "document" }}
                  />
                  <ActionButton
                    onClick={() => {
                      handleSave();
                    }}
                    icon={FaSave}
                    title="Sauvegarder"
                    subtitle="Sauvegarder l'étude"
                    colors={{
                      primary: "rgb(124, 58, 237)",
                      secondary: "rgb(109, 40, 217)",
                      shadow: "rgba(124, 58, 237, 0.4)",
                      shadowHover: "rgba(124, 58, 237, 0.6)",
                      background: "linear-gradient(135deg, rgb(124, 58, 237) 0%, rgb(109, 40, 217) 100%)",
                    }}
                    decorativeIcon={{ type: "save" }}
                  />

                  <ActionButton
                    onClick={() => {
                      handleGoToAudits();
                    }}
                    icon={FaArrowLeft}
                    title="Quitter"
                    subtitle="Revenir aux audits"
                    colors={{
                      primary: "#e57373",
                      secondary: "#c62828",
                      shadow: "rgba(229, 115, 115, 0.4)",
                      shadowHover: "rgba(229, 115, 115, 0.6)",
                    }}
                    decorativeIcon={{ type: "previous" }}
                  />
                </div>
              </Column>
            </CardBox>
            <CardBox tpad bpad className="blockRoundedForce" style={{ marginTop: "00px", padding: "25px 25px 25px 15px" }}>
              <div className="revenuspro-container" style={{ marginBottom: "20px", paddingLeft: "0px" }}>
                {/* Titre au-dessus du tableau */}
                <div className="dossier-header" style={{ marginBottom: "15px", paddingLeft: "0px" }}>
                  <div className="dossier-header-icon">
                    <FaCalculator />
                  </div>
                  <h1 className="dossier-header-title">Détail de l'enveloppe Madelin dans le cadre de la déclaration</h1>
                </div>

                <div className="card-list-container">

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">💰</div>
                      Montant
                    </div>
                    <div className="value-column">{applyFormat(resultat.MontantAssietteDisponible, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                  </div>
                </div>

                {/* Header avec 4 colonnes */}
                <div className="header-card" style={{ marginTop: "15px" }}>
                  <div className="category-column" style={{ flex: 2, textAlign: "left" }}></div>
                  <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                    Assiette
                  </div>
                  <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                    Taux
                  </div>
                  <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                    Montant
                  </div>
                </div>

                {/* Conteneur des cartes de contenu */}
                <div className="card-list-container">
                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">📊</div>
                      Limite des 10%
                    </div>
                    <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                      {applyFormat(resultat.MontantAssietteDisponibleT1, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                    </div>
                    <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                      10%
                    </div>
                    <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                      {applyFormat(resultat.MontantDisponibleT1, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">📈</div>
                      Limite des 15%
                    </div>
                    <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                      {applyFormat(resultat.MontantAssietteDisponibleT2, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                    </div>
                    <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                      15%
                    </div>
                    <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                      {applyFormat(resultat.MontantDisponibleT2, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                    </div>
                  </div>

                  <div className="card" style={{ fontWeight: "bold" }}>
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">💯</div>
                      Cumul
                    </div>
                    <div className="value-column" style={{ flex: 1, textAlign: "center" }}></div>
                    <div className="value-column" style={{ flex: 1, textAlign: "center" }}></div>
                    <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                      {applyFormat(resultat.MontantDisponibleT1 + resultat.MontantDisponibleT2, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                    </div>
                  </div>
                </div>
              </div>
            </CardBox>
            <CardBox bpad className="blockRoundedForce" style={{ marginTop: "10px", padding: "25px" }}>
              <div className="revenuspro-container" style={{ marginBottom: "20px", paddingLeft: "0px" }}>
                {/* Titre au-dessus du tableau */}
                <div className="dossier-header" style={{ marginBottom: "15px" }}>
                  <div className="dossier-header-icon">
                    <FaFileAlt />
                  </div>
                  <h1 className="dossier-header-title">Déclaration à effectuer</h1>
                </div>
                <div className="card-list-container">
                  <div className="card">
                    <div className="category-column" style={{ flex: 2, textAlign: "right" }}>
                      <div className="titre-icone">🏦</div>
                      Cotisations PER Madelin {yearM1}
                    </div>
                    <div className="value-column">{applyFormat(values.DeclaPERRetraiteMadelin, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2, textAlign: "right" }}>
                      <div className="titre-icone">📋</div>
                      Montant à déclarer (Cotisation Madelin-Part des 15%)
                    </div>
                    <div className="value-column">{applyFormat(resultat.MontantADeclarer, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                  </div>
                </div>
              </div>
            </CardBox>
          </Column>
        </Row>
      </Column>
    </>
  );
};

export default DeclarationPER;
